import { Button, Empty } from "antd"
import { getFirstTownOfCityCode } from "api/user"
import useAreaCookie from "hooks/useAreaCookie"
import { useRouter } from "next/router"
import { cls } from "reactutils"
import AreaCascader from "./AreaCascader"

export default function AreaEmptyData({
  areaLevel = 2,
  height = "320px",
  customStyle,
}: {
  areaLevel?: number
  height?: string
  customStyle?: string
}) {
  const router = useRouter()
  const {
    areaSysNo,
    setCookie,
    AREA_CODE_KEY,
    AREA_SYS_NO_KEY,
  } = useAreaCookie()

  async function handleAreaChange(data: string[]) {
    // console.log(data)
    if (!data || !data?.length) return
    // 根据市 查询最后一级地区信息
    let res = await getFirstTownOfCityCode(data[data.length - 1])
    if (res?.code === 200 && res?.data) {
      const levelCode: string = res.data.levelCode
      setCookie(AREA_SYS_NO_KEY, res.data.sysNo)
      setCookie(AREA_CODE_KEY, levelCode)
      router.reload()
    }
  }

  return (
    <>
      <div className={cls("nodata-container", customStyle)}>
        <div className="notfound">
          <Empty
            description={
              <div className="content">
                <span>
                  该区域暂无可售商品，请
                  <Button type="link">切换到其他区域</Button>
                  看看!
                </span>
                <AreaCascader
                  placeholder="请选择"
                  value={areaSysNo}
                  areaLevel={areaLevel}
                  curLevelAreaName
                  onChange={handleAreaChange}
                  trigger="click"
                />
              </div>
            }
            imageStyle={{ height: "100px" }}
          />
        </div>
      </div>
      <style jsx>{`
        .nodata-container {
          width: 100%;
          height: ${height ? height : "calc(100vh - 115px)"};
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .notfound {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }

        .content {
          position: relative;
        }

        .content :global(.cascader) {
          width: 100px;
          text-align: left;
          position: absolute;
          top: 5px;
          right: 32px;
          color: rgba(255, 255, 255, 0);
        }

        .content :global(.cascader-hd-icon) {
          visibility: hidden;
        }

        .notfound :global(.ant-empty-description) {
          font-size: 14px;
          color: #333333;
        }

        .notfound :global(.ant-btn) {
          padding: 0;
        }
      `}</style>
    </>
  )
}
